import React, { useState } from "react";

// Images
import img1 from "../Accests/images/beach/IMG-20250630-WA0017.jpg";
import img2 from "../Accests/images/beach/IMG-20250630-WA0023.jpg";
import img3 from "../Accests/images/beach/IMG-20250630-WA0027.jpg";
import img4 from "../Accests/images/beach/IMG-20250630-WA0028.jpg";

// Videos
import vid1 from "../Accests/images/beach/VID-20250630-WA0009.mp4";
import vid2 from "../Accests/images/beach/VID-20250630-WA0004.mp4";

const BeachParty = () => {
    const [previewSrc, setPreviewSrc] = useState(null);
    const [isVideo, setIsVideo] = useState(false);

    const openPreview = (src, type) => {
        setPreviewSrc(src);
        setIsVideo(type === "video");
    };

    const closePreview = () => {
        setPreviewSrc(null);
        setIsVideo(false);
    };

    return (
        <>
            <div className="pt-24 px-6 bg-gray-100 min-h-screen">
                <h1 className="text-4xl font-bold text-center mb-8 text-teal-600">Beach Party</h1>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {[img1, img2, img3, img4].map((img, i) => (
                        <img
                            key={i}
                            src={img}
                            alt={`Beach Party ${i + 1}`}
                            onClick={() => openPreview(img, "image")}
                            className="w-full h-64 object-cover rounded-lg cursor-pointer shadow hover:scale-105 transition"
                        />
                    ))}

                    {[vid1, vid2].map((vid, i) => (
                        <video
                            key={i}
                            src={vid}
                            onClick={() => openPreview(vid, "video")}
                            className="w-full h-64 object-cover rounded-lg cursor-pointer shadow hover:scale-105 transition"
                            muted
                            autoPlay
                            loop
                        />
                    ))}
                </div>

                <p className="text-gray-700 mt-6 text-lg leading-relaxed text-center">
                    Join us for a vibrant beach party filled with fun activities, upbeat music, and stunning views by the sea.
                </p>
            </div>

            {/* Preview Modal */}
            {previewSrc && (
                <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
                    {/* Overlay click to close */}
                    <div className="absolute inset-0" onClick={closePreview}></div>

                    <div className="relative z-10 max-w-4xl w-full p-4">
                        <button
                            onClick={closePreview}
                            className="absolute top-4 right-4 z-20 bg-white text-black rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold hover:bg-red-600 hover:text-white transition"
                        >
                            &times;
                        </button>
                        {isVideo ? (
                            <video src={previewSrc} className="w-full rounded-lg" controls autoPlay />
                        ) : (
                            <img src={previewSrc} alt="Preview" className="w-full rounded-lg" />
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default BeachParty;
